import type {
    AuthService,
    UploadService,
    LeadTimeService,
    SupplierControlService,
    SupplierInsightsService,
} from './types';
import { awsAuthService } from './aws/awsAuthService';
import { awsUploadService } from './aws/awsUploadService';
import { awsLeadTimeService } from './aws/awsLeadTimeService';
import { awsSupplierControlService } from './aws/awsSupplierControlService';
import { awsSupplierInsightsService } from './aws/awsSupplierInsightsService';

/**
 * Resolves the active auth + upload implementation. Backed by real Cognito/S3
 * (via Amplify), configured from the runtime config loaded at startup.
 */
export function getAuthService(): AuthService {
    return awsAuthService;
}

export function getUploadService(): UploadService {
    return awsUploadService;
}

export function getLeadTimeService(): LeadTimeService {
    return awsLeadTimeService;
}

export function getSupplierControlService(): SupplierControlService {
    return awsSupplierControlService;
}

export function getSupplierInsightsService(): SupplierInsightsService {
    return awsSupplierInsightsService;
}
